

































import {Component, Vue} from 'vue-property-decorator';
import {Color, Option} from '@/types/gripper';
import {colorArray} from '@/plugins/Color';
import {
  PipelineInfo,
  PipelineInfo_pipeline_parameter_options,
  PipelineInfo_pipeline_parameter, PipelineInfoVariables,
} from '@/types/intrador';
import PaginateButtonsShrinkingBin from '@/layouts/gripper/components/QuickLabeling/PaginateButtonsShrinkingBin.vue';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import QuickReviewing from '@/layouts/gripper/QuickReviewing.vue';

@Component({
  components: {
    IntradorLoader,
    PaginateButtonsShrinkingBin,
    QuickReviewing,
  },
})
export default class PipelineInformation extends Vue {

  private pipelineInfo: PipelineInfo | null = null;
  private options: Option[] = [];
  private selectedParameterOption: Option | null = null;
  private parameter: PipelineInfo_pipeline_parameter | null = null;

  get queryVariables() {
    return {
      pipelineID: this.$route.params.pipelineID,
    } as PipelineInfoVariables;
  }

  private resolveData(data: PipelineInfo) {
    this.pipelineInfo = data;
    this.parameter = data.pipeline.parameter;
    this.options = this.allPossibleOptions(data);

    this.setDefaultLabel();

    localStorage.setItem('pipeline_id', this.pipelineInfo.pipeline.id);
    localStorage.setItem('parameter_id', this.parameter.id);
    if (this.selectedParameterOption !== null) {
      localStorage.setItem('option_id', this.selectedParameterOption.id);
    }

    return data;
  }

  private allPossibleOptions(data: PipelineInfo): Option[] {
    if (!data.pipeline.parameter?.options) {
      return [];
    }

    return data.pipeline.parameter.options.map((item: PipelineInfo_pipeline_parameter_options, index: number) => {
      return {
        id: item.id,
        value: item.value,
        color: this.getRandomColorStyle(index),
      } as Option;
    }).reverse();
  }

  // get the default label (first label in the list)
  private setDefaultLabel() {
    if (!this.selectedParameterOption && this.options.length > 0) {
      this.selectedParameterOption = this.options[0];
    }
  }

  private getRandomColorStyle(index: number): Color {
    const colorString = (colorArray[index]);
    return {backgroundColor: colorString} as Color;
  }

  private goToNewLabelCategory(option: Option) {
    this.selectedParameterOption = option;

    localStorage.setItem('option_id', this.selectedParameterOption.id);
  }


}
